import { render } from "./OutlayRow.vue?vue&type=template&id=3d135c12&scoped=true"
import script from "./OutlayRow.vue?vue&type=script&lang=js"
export * from "./OutlayRow.vue?vue&type=script&lang=js"

import "./OutlayRow.vue?vue&type=style&index=0&id=3d135c12&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/embody-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d135c12"]])

export default __exports__